import { useState } from 'react';
import { useI18n } from '../i18n';
import { useScrolled } from '../hooks/useScrolled';
import { STORE_URL } from '../constants';
import { Brand } from './Brand';
import { LanguageToggle } from './LanguageToggle';
import { MenuIcon, CloseIcon } from './icons';

/**
 * Fixed top bar. Transparent over the hero, then blurs/borders once scrolled.
 * On narrow screens the links collapse into a full-screen overlay toggled by the
 * burger button; picking a link closes it.
 */
export const Header = () => {
  const { t } = useI18n();
  const scrolled = useScrolled(40);
  const [open, setOpen] = useState(false);

  const close = () => setOpen(false);

  return (
    <header className={scrolled ? 'scrolled' : ''}>
      <div className="wrap nav">
        <Brand />

        <nav className={`nav-links${open ? ' open' : ''}`}>
          <a href="#foto" onClick={close}>
            {t.nav.virtual}
          </a>
          <a href="#museu" onClick={close}>
            {t.nav.museum}
          </a>
          <a href="#visitar" onClick={close}>
            {t.nav.visit}
          </a>
          <a className="store" href={STORE_URL} target="_blank" rel="noopener" onClick={close}>
            {t.nav.store}
          </a>
          <LanguageToggle />
        </nav>

        <div className="nav-right">
          <LanguageToggle />
          <button
            type="button"
            className={`burger${open ? ' open' : ''}`}
            onClick={() => setOpen((v) => !v)}
            aria-label={t.nav.menu}
            aria-expanded={open}
          >
            {open ? <CloseIcon /> : <MenuIcon />}
          </button>
        </div>
      </div>
    </header>
  );
};
